import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
export const useNotesSelectionCount = (): number => {
  const { control } = useFormContext();
  const values = useWatch({ control });
  return useMemo(
    () =>
      Object.keys(values).reduce(
        (acc, key) => (key.indexOf('_') >= 0 && values[key] ? acc + 1 : acc),
        0
      ),
    [values]
  );
};
